import { useEffect } from 'react'
import termsText from '../legal/love-and-photos-terms.txt?raw'

const headingPattern = /^(\d+\.|\d+\.\d+[A-Z]?|CONTACT INFORMATION|ACCEPTANCE:)/

function renderTermsLine(line, index) {
  const trimmed = line.trim()

  if (!trimmed) return null

  if (trimmed === 'IMPORTANT:') {
    return (
      <h2 key={index} className="text-xl font-semibold text-foreground mb-3">
        IMPORTANT:
      </h2>
    )
  }

  if (headingPattern.test(trimmed)) {
    const isTopLevel = /^(\d+\. [A-Z]|CONTACT INFORMATION|ACCEPTANCE:)/.test(trimmed)
    const HeadingTag = isTopLevel ? 'h2' : 'h3'
    return (
      <HeadingTag
        key={index}
        className={
          isTopLevel
            ? 'text-2xl font-display font-semibold text-foreground mt-10 mb-4'
            : 'text-lg font-semibold text-foreground mt-6 mb-2'
        }
      >
        {trimmed}
      </HeadingTag>
    )
  }

  if (trimmed.startsWith('•')) {
    return (
      <p key={index} className="leading-relaxed pl-5">
        {trimmed}
      </p>
    )
  }

  return (
    <p key={index} className="leading-relaxed mb-4">
      {trimmed}
    </p>
  )
}

const TermsAndConditions = () => {
  const lines = termsText.replace(/\r\n/g, '\n').split('\n')
  const title = lines[0]?.trim() || 'Terms and Conditions for Love & Photos'
  const lastUpdated = lines[1]?.trim() || ''
  const bodyLines = lines.slice(2)
  const importantIndex = bodyLines.findIndex(line => line.trim() === 'IMPORTANT:')
  const afterImportantIndex = importantIndex >= 0
    ? bodyLines.findIndex((line, index) => index > importantIndex && /^1\./.test(line.trim()))
    : -1
  const importantLines = importantIndex >= 0 && afterImportantIndex > importantIndex
    ? bodyLines.slice(importantIndex, afterImportantIndex)
    : []
  const mainLines = importantLines.length
    ? bodyLines.slice(0, importantIndex).concat(bodyLines.slice(afterImportantIndex))
    : bodyLines

  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash)
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)
        return
      }
    }
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-card rounded-lg shadow-lg p-8 sm:p-12 border">
          <h1 className="text-4xl font-display font-bold text-foreground mb-4">
            {title}
          </h1>
          {lastUpdated && (
            <p className="text-muted-foreground mb-8">{lastUpdated}</p>
          )}

          {importantLines.length > 0 && (
            <div className="bg-muted/50 border-l-4 border-primary p-6 mb-8">
              {importantLines.map(renderTermsLine)}
            </div>
          )}

          <div className="space-y-1 text-muted-foreground">
            {mainLines.map(renderTermsLine)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsAndConditions
